export default __webpack_public_path__ + "static/img-1-31fe1e69686908169b38ba60a04cd070.png";